import { useLocalStorage } from '@gravitate-js/excalibrr'
import type { CostRevenueType } from '../types/common'

/**
 * Hook to manage cost/revenue selection with persistent storage
 * @returns The current value and setter function
 */
export const useCostRevenueSelection = (): [CostRevenueType, (value: CostRevenueType) => void] => {
  const { value: costRevenue, setValue: setCostRevenue } = useLocalStorage<CostRevenueType>('costRevenue', 'Revenue')

  return [costRevenue as CostRevenueType, setCostRevenue]
}
